import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';
import {
  PRESCRIPTION,
  PRESCRIPTION_CLOSE,
  PRESCRIPTION_SHOW
} from './prescriptionActions';

const prescriptionReducer = createResourceReducer(PRESCRIPTION, [], {
  [PRESCRIPTION_SHOW](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      visible: true,
      forceDefaultPrescription: action.payload
    }));
  },

  [PRESCRIPTION_CLOSE](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      visible: false
    }));
  }
});

export default prescriptionReducer;
